import { requisitionsProductListStyles } from "@insite/content-library/Widgets/Requisitions/RequisitionsProductList";
import { css } from "styled-components";

Object.assign(requisitionsProductListStyles, {
    ...requisitionsProductListStyles,
    selectAllCheckbox: {
        css: css`
            margin-left: 20px;
            span[role="checkbox"][aria-checked="true"]:not([aria-disabled="true"]) {
                background: #fff;
                border: 1px solid #bebdbd;
                color: #19a3e0;
            }
            span[role="checkbox"]:focus {
                outline: none;
                box-shadow: 0 0 0 1px #e2e3e6;
            }
        `,
    },
});
